<template>
  <div class="w-100 pb-3">
    <div class="row">
      <div class="col-12 col-lg-3">
        <div class="row">
          <!-- Today Request & Today Self Check-In -->
          <div
            v-for="(
              todayStatusCount, todayStatusCountIndex
            ) in todayStatusCountList"
            :key="todayStatusCountIndex"
            :class="[
              [
                todayStatusCount.titleName === 'Today Request'
                  ? 'today-request-count__container'
                  : 'today-self-check-in-count__container',
              ],
              colClassTodayStatusCount,
            ]"
          >
            <molecule-dashboard-container
              :title="todayStatusCount.titleName"
              :isLoading="todayStatusCount.isLoading"
              :isBgHeader="true"
            >
              <template #body>
                <div
                  class="d-flex flex-column align-items-center justify-content-center mt-1"
                >
                  <div class="text-status-count">
                    {{
                      todayStatusCount.requestCount ||
                      todayStatusCount.personCount ||
                      0
                    }}
                  </div>
                  <div class="text-sub-title text-center">
                    {{ todayStatusCount.subText }}
                  </div>
                </div>
              </template>
            </molecule-dashboard-container>
          </div>
        </div>

        <!-- Today Self Check-In -->
        <div class="row site-access-status__row">
          <div class="col-12 site-access-status__container">
            <molecule-dashboard-container
              title="Today Self Check-In"
              :isTitleEllipsis="true"
              :isLoading="isLoadingTodaySelfCheckIn"
              classHeaderLayout="d-flex"
            >
              <template #header>
                <b-badge pill variant="light-primary" class="badge--style"
                  >{{ todaySelfCheckInList.length }} All
                </b-badge>
              </template>
              <template #body>
                <div
                  v-if="!todaySelfCheckInList.length"
                  class="today-self-check-in-no-data-height"
                >
                  <div
                    class="d-flex flex-column align-items-center justify-content-center h-100"
                  >
                    <feather-icon icon="CloudOffIcon" class="icon_folder" />
                    No Today Self Check-in
                  </div>
                </div>
                <div v-else class="w-100 today-self-check-in-height">
                  <div
                    v-for="(
                      todaySelfCheckIn, todaySelfCheckInIndex
                    ) in todaySelfCheckInList"
                    :key="todaySelfCheckInIndex"
                    class="self-check-in-card"
                  >
                    <div
                      class="self-check-in-info d-flex pb-1"
                      :class="{ 'pt-1': todaySelfCheckInIndex !== 0 }"
                      @click="
                        goToSiteAccessDetail(
                          todaySelfCheckIn.siteAccessId,
                          todaySelfCheckIn.accessVisitorId
                        )
                      "
                    >
                      <img
                        v-if="todaySelfCheckIn.imgUrl"
                        :src="todaySelfCheckIn.imgUrl"
                        class="avatar__size"
                      />
                      <b-avatar
                        v-else
                        variant="light-secondary"
                        rounded="sm"
                        class="avatar__size"
                      ></b-avatar>
                      <div
                        class="d-flex flex-column justify-content-between ml-1"
                      >
                        <label class="text__check-in">{{
                          todaySelfCheckIn.checkInDate
                        }}</label>
                        <label class="text__name mb-0">{{
                          todaySelfCheckIn.name
                        }}</label>
                        <label class="text__id mb-0"
                          >ID/Passport No.
                          {{ todaySelfCheckIn.identity }}</label
                        >
                        <div class="custom-margin-top-8">
                          <b-badge
                            variant="light-secondary"
                            class="badge--style badge--small-size"
                            >{{ todaySelfCheckIn.siteName || "-" }}
                          </b-badge>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </molecule-dashboard-container>
          </div>
        </div>

        <!-- Status (30 Days) -->
        <div class="row site-access-status__row">
          <div class="col-12 site-access-status__container">
            <molecule-dashboard-container
              title="Status (30 Days)"
              :isTitleEllipsis="true"
              :isLoading="isLoadingSiteAccessStatusCount"
              classHeaderLayout="d-flex"
            >
              <template #header>
                <b-badge pill variant="light-primary" class="badge--style"
                  >{{ siteAccessStatusCountAll }} All
                </b-badge>
              </template>
              <template #body>
                <div class="w-100">
                  <div class="row">
                    <div
                      v-for="(
                        siteAccessStatusCount, siteAccessStatusCountIndex
                      ) in filteredSiteAccessStatusCountList"
                      :key="siteAccessStatusCountIndex"
                      class="col-12 mb-1"
                    >
                      <span> {{ siteAccessStatusCount.title }}</span>
                      <div class="d-flex align-items-center">
                        <div class="w-100 mr-1">
                          <atom-bootstrap-progress-bar
                            :value="siteAccessStatusCount.value"
                            :max="siteAccessStatusCountAll"
                          ></atom-bootstrap-progress-bar>
                        </div>
                        <div class="d-flex flex-grow-1 justify-content-end">
                          <span class="site-access-status-text">{{
                            siteAccessStatusCount.value
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </molecule-dashboard-container>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-9 col-pl-7px">
        <!-- Today Site Access (Access) -->
        <div class="today-site-access__container">
          <molecule-dashboard-container
            title="Today Site Access (Access)"
            bodyContainerClass="px-0"
            :isLoading="isLoadingTodaySiteAccess"
          >
            <template #body>
              <div
                v-if="!todaySiteAccessList.length"
                class="table-container-no-data-height"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-center h-100"
                >
                  <feather-icon icon="CloudOffIcon" class="icon_folder" />
                  No Today Site Access (Access)
                </div>
              </div>
              <div
                v-else
                class="w-100 d-flex flex-column justify-content-between"
              >
                <div>
                  <b-table
                    responsive
                    sticky-header
                    :items="todaySiteAccessList"
                    :fields="fields"
                    :hover="true"
                    @row-clicked="selectRowTableSiteAccessDashboard"
                    class="table-container-height"
                  >
                    <template #cell(id)="data">
                      <div class="header">{{ data.value.siteAccessId }}</div>
                      <div class="sub-header mt-4px">
                        {{ `${contractIdLabel}: ${data.value.idcId || "-"}` }}
                      </div>
                      <b-badge
                        pill
                        :variant="badgeVariant(data.value.status)"
                        class="text-size-10 mt-8px"
                        >{{ badgeStatus(data.value.status) }}</b-badge
                      >
                    </template>
                    <template #cell(site)="data">
                      <div>{{ data.value }}</div>
                    </template>
                    <template #cell(requestStart)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(requestEnd)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(latestCheckIn)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(latestCheckOut)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(visitors)="data">
                      <div class="visitors-container-width">
                        <div v-if="data.value.length">
                          <div
                            v-for="(visitor, index) in data.value.slice(0, 3)"
                            :key="index"
                          >
                            <li>{{ visitor }}</li>
                          </div>
                          <div
                            :id="'visitor-access-' + data.index"
                            class="sub-header mt-4px"
                            v-if="data.value.length > 3"
                          >
                            +{{ data.value.length - 3 }} Visitors
                          </div>
                          <b-popover
                            v-if="data.value.length > 3"
                            ref="popover"
                            :target="'visitor-access-' + data.index"
                            triggers="hover"
                            placement="right"
                            container="my-container"
                            boundary="window"
                          >
                            <template v-slot:title>
                              <div
                                class="d-flex justify-content-between align-items-left"
                              >
                                <span class="font-size-14">All Visitors</span>
                              </div>
                            </template>
                            <div class="pl-1">
                              <li
                                v-for="(visitor, index) in data.value"
                                :key="index"
                              >
                                {{ visitor }}
                              </li>
                            </div>
                          </b-popover>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between pagination-padding"
                >
                  <div>Showing {{ todaySiteAccessList.length }} entries</div>
                  <div>
                    <b-pagination
                      v-model="filterList.currentPageTodaySiteAccess"
                      :total-rows="filterList.totalCountTodaySiteAccess"
                      :per-page="perPage"
                      @change="handleCurrentPageTodaySiteAccess"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </template>
          </molecule-dashboard-container>
        </div>

        <!-- Today Site Access (Approved) -->
        <div class="today-site-approved__container">
          <molecule-dashboard-container
            title="7 Days Upcoming Site Access (Approved)"
            bodyContainerClass="px-0"
            :isLoading="isLoadingTodaySiteApproved"
          >
            <template #body>
              <div
                v-if="!todaySiteApprovedList.length"
                class="table-container-no-data-height"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-center h-100"
                >
                  <feather-icon icon="CloudOffIcon" class="icon_folder" />
                  No 7 Days Upcoming Site Access (Approved)
                </div>
              </div>
              <div
                v-else
                class="w-100 d-flex flex-column justify-content-between"
              >
                <div>
                  <b-table
                    responsive
                    sticky-header
                    :items="todaySiteApprovedList"
                    :fields="fields"
                    :hover="true"
                    @row-clicked="selectRowTableSiteAccessDashboard"
                    class="table-container-height"
                  >
                    <template #cell(id)="data">
                      <div class="header">{{ data.value.siteAccessId }}</div>
                      <div class="sub-header mt-4px">
                        {{ `${contractIdLabel}: ${data.value.idcId || "-"}` }}
                      </div>
                      <b-badge
                        pill
                        :variant="badgeVariant(data.value.status)"
                        class="text-size-10 mt-8px"
                        >{{ badgeStatus(data.value.status) }}</b-badge
                      >
                    </template>
                    <template #cell(site)="data">
                      <div>{{ data.value }}</div>
                    </template>
                    <template #cell(requestStart)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(requestEnd)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(latestCheckIn)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(latestCheckOut)="data">
                      <div>{{ data.value.date || "-" }}</div>
                      <div class="sub-header">{{ data.value.time }}</div>
                    </template>
                    <template #cell(visitors)="data">
                      <div class="visitors-container-width">
                        <div v-if="data.value.length">
                          <div
                            v-for="(visitor, index) in data.value.slice(0, 3)"
                            :key="index"
                          >
                            <li>{{ visitor }}</li>
                          </div>
                          <div
                            :id="'visitor-approved-' + data.index"
                            class="sub-header mt-4px"
                            v-if="data.value.length > 3"
                          >
                            +{{ data.value.length - 3 }} Visitors
                          </div>
                          <b-popover
                            v-if="data.value.length > 3"
                            ref="popover"
                            :target="'visitor-approved-' + data.index"
                            triggers="hover"
                            placement="right"
                            container="my-container"
                            boundary="window"
                          >
                            <template v-slot:title>
                              <div
                                class="d-flex justify-content-between align-items-left"
                              >
                                <span class="font-size-14">All Visitors</span>
                              </div>
                            </template>
                            <div class="pl-1">
                              <li
                                v-for="(visitor, index) in data.value"
                                :key="index"
                              >
                                {{ visitor }}
                              </li>
                            </div>
                          </b-popover>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between pagination-padding"
                >
                  <div>Showing {{ todaySiteApprovedList.length }} entries</div>
                  <div>
                    <b-pagination
                      v-model="filterList.currentPageTodaySiteApproved"
                      :total-rows="filterList.totalCountTodaySiteApproved"
                      :per-page="perPage"
                      @change="handleCurrentPageTodaySiteApproved"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </template>
          </molecule-dashboard-container>
        </div>
      </div>
    </div>

    <!-- Past Site Access -->
    <div class="past-site-access-row">
      <div>
        <molecule-dashboard-container
          title="Past Site Access"
          bodyContainerClass="px-0"
          :isLoading="isLoadingPastSiteAccess"
        >
          <template #body>
            <div
              v-if="!pastSiteAccessList.length"
              class="table-container-no-data-height"
            >
              <div
                class="d-flex flex-column align-items-center justify-content-center h-100"
              >
                <feather-icon icon="CloudOffIcon" class="icon_folder" />
                No Today Site Access (Access)
              </div>
            </div>
            <div
              v-else
              class="w-100 d-flex flex-column justify-content-between"
            >
              <div>
                <b-table
                  responsive
                  sticky-header
                  :items="pastSiteAccessList"
                  :fields="fields"
                  :hover="true"
                  @row-clicked="selectRowTableSiteAccessDashboard"
                  class="table-container-height"
                >
                  <template #cell(id)="data">
                    <div class="header">{{ data.value.siteAccessId }}</div>
                    <div class="sub-header mt-4px">
                      {{ `${contractIdLabel}: ${data.value.idcId || "-"}` }}
                    </div>
                    <b-badge
                      pill
                      :variant="badgeVariant(data.value.status)"
                      class="text-size-10 mt-8px"
                      >{{ badgeStatus(data.value.status) }}</b-badge
                    >
                  </template>
                  <template #cell(site)="data">
                    <div>{{ data.value }}</div>
                  </template>
                  <template #cell(requestStart)="data">
                    <div>{{ data.value.date || "-" }}</div>
                    <div class="sub-header">{{ data.value.time }}</div>
                  </template>
                  <template #cell(requestEnd)="data">
                    <div>{{ data.value.date || "-" }}</div>
                    <div class="sub-header">{{ data.value.time }}</div>
                  </template>
                  <template #cell(latestCheckIn)="data">
                    <div>{{ data.value.date || "-" }}</div>
                    <div class="sub-header">{{ data.value.time }}</div>
                  </template>
                  <template #cell(latestCheckOut)="data">
                    <div>{{ data.value.date || "-" }}</div>
                    <div class="sub-header">{{ data.value.time }}</div>
                  </template>
                  <template #cell(visitors)="data">
                    <div class="visitors-container-width">
                      <div v-if="data.value.length">
                        <div
                          v-for="(visitor, index) in data.value.slice(0, 3)"
                          :key="index"
                        >
                          <li>{{ visitor }}</li>
                        </div>
                        <div
                          :id="'visitor-past-' + data.index"
                          class="sub-header mt-4px"
                          v-if="data.value.length > 3"
                        >
                          +{{ data.value.length - 3 }} Visitors
                        </div>
                        <b-popover
                          v-if="data.value.length > 3"
                          ref="popover"
                          :target="'visitor-past-' + data.index"
                          triggers="hover"
                          placement="right"
                          container="my-container"
                          boundary="window"
                        >
                          <template v-slot:title>
                            <div
                              class="d-flex justify-content-between align-items-left"
                            >
                              <span class="font-size-14">All Visitors</span>
                            </div>
                          </template>
                          <div class="pl-1">
                            <li
                              v-for="(visitor, index) in data.value"
                              :key="index"
                            >
                              {{ visitor }}
                            </li>
                          </div>
                        </b-popover>
                      </div>
                      <div v-else>-</div>
                    </div>
                  </template>
                </b-table>
              </div>
              <div
                class="d-flex align-items-center justify-content-between pagination-padding"
              >
                <div>Showing {{ pastSiteAccessList.length }} entries</div>
                <div>
                  <b-pagination
                    v-model="filterList.currentPagePastSiteAccess"
                    :total-rows="filterList.totalCountPastSiteAccess"
                    :per-page="perPage"
                    @change="handleCurrentPagePastSiteAccessChange"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </template>
        </molecule-dashboard-container>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BCard,
  BTable,
  BPagination,
  BPopover,
} from "bootstrap-vue"
import { mapGetters } from "vuex"
import AtomBootstrapProgressBar from "@/components/atoms/graphs/AtomBootstrapProgressBar.vue"
import MoleculeDashboardContainer from "@/components/molecules/MoleculeDashboardContainer.vue"
import VueScreenSize from "vue-screen-size"
import mixins from "@/mixins"

export default {
  name: "OrganismQrAccessDashboard",
  components: {
    BAvatar,
    BBadge,
    BCard,
    BTable,
    BPagination,
    BPopover,
    AtomBootstrapProgressBar,
    MoleculeDashboardContainer,
  },
  mixins: [mixins, VueScreenSize.VueScreenSizeMixin],
  props: {
    fields: {
      type: Array,
      required: true,
    },
    todayStatusCountList: {
      type: Array,
      required: true,
    },
    todaySiteApprovedList: {
      type: Array,
      required: true,
    },
    isLoadingTodaySiteApproved: {
      type: Boolean,
      required: true,
    },
    todaySiteAccessList: {
      type: Array,
      required: true,
    },
    isLoadingTodaySiteAccess: {
      type: Boolean,
      required: true,
    },
    siteAccessStatusCountList: {
      type: Array,
      required: true,
    },
    isLoadingSiteAccessStatusCount: {
      type: Boolean,
      required: true,
    },
    todaySelfCheckInList: {
      type: Array,
      required: true,
    },
    isLoadingTodaySelfCheckIn: {
      type: Boolean,
      required: true,
    },
    pastSiteAccessList: {
      type: Array,
      required: true,
    },
    isLoadingPastSiteAccess: {
      type: Boolean,
      required: true,
    },
    filterList: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      perPage: 10,
    }
  },
  emits: [
    "selectRowTableSiteAccessDashboard",
    "changeCurrentPageTodaySiteApproved",
    "changeCurrentPageTodaySiteAccess",
    "changeCurrentPagePastSiteAccess",
  ],
  computed: {
    ...mapGetters("appPermission", ["getIdcId"]),

    screenWidth() {
      return this.$vssWidth
    },

    idcId() {
      return !!this.getIdcId ? this.getIdcId.toString().padStart(8, "0") : "-"
    },

    colClassTodayStatusCount() {
      if (this.screenWidth > 992 && this.screenWidth < 1840) {
        return "col-12"
      } else {
        return "col-6"
      }
    },

    filteredSiteAccessStatusCountList() {
      return this.siteAccessStatusCountList.filter(
        (item) => item.title !== "Total"
      )
    },

    siteAccessStatusCountAll() {
      return (
        this.siteAccessStatusCountList.find((item) => item.title === "Total")
          ?.value || 0
      )
    },
  },
  methods: {
    selectRowTableSiteAccessDashboard(data) {
      this.$emit("selectRowTableSiteAccessDashboard", data)
    },

    handleCurrentPageTodaySiteApproved(page) {
      this.filterList.currentPageTodaySiteApproved = page
      this.$emit("changeCurrentPageTodaySiteApproved")
    },

    handleCurrentPageTodaySiteAccess(page) {
      this.filterList.currentPageTodaySiteAccess = page
      this.$emit("changeCurrentPageTodaySiteAccess")
    },

    handleCurrentPagePastSiteAccessChange(page) {
      this.filterList.currentPagePastSiteAccess = page
      this.$emit("changeCurrentPagePastSiteAccess")
    },

    badgeVariant(status) {
      if (status === "ACCESS") return "light-primary"
      else if (status === "APPROVED") return "light-success"
      else if (status === "WAITING") return "light-warning"
      else if (status === "REJECTED") return "light-danger"
      else return "light-secondary"
    },
    badgeStatus(status) {
      if (status === "ACCESS") return "Access"
      else if (status === "APPROVED") return "Approved"
      else if (status === "WAITING") return "Waiting"
      else if (status === "REJECTED") return "Rejected"
      else return "Closed"
    },

    goToSiteAccessDetail(siteAccessId, accessVisitorId) {
      const basePath = "/internal/web-portal/site-access/"
      this.$router.push({
        path: basePath + siteAccessId,
        query: { visitorId: accessVisitorId },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .progress {
  height: 8px;
}

.col-pl-7px {
  padding-left: 7px;
}

.visitors-container-width {
  min-width: 200px;
}

.text-status-count {
  text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  color: #7367f0;
  font-weight: 700;
  font-size: 24px;
}

.today-request-count__container {
  padding-right: 7px;
}

.today-self-check-in-count__container {
  padding-right: 7px;
}

.today-site-approved__container {
  margin-top: 14px;
}

.text-sub-title {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 4px;
}

.pagination-padding {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.site-access-status__row {
  margin-top: 14px;
}

.site-access-status__container {
  padding-right: 7px;
}

.site-access-status-text {
  color: #7367f0;
  font-weight: 700;
  text-align: right;
  min-width: 20px;
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge--small-size {
  font-size: 10px;
}

.self-check-in-card:hover {
  cursor: pointer;
  background-color: #f6f6f9;
}

.self-check-in-info {
  border-bottom: 1px solid #ebe9f1;
}

.avatar__size {
  border-radius: 6px;
  width: 80px;
  height: 100px;
  object-fit: cover;
}

.text__check-in {
  color: #7367f0;
  font-size: 14px;
  font-weight: 600;
}

.text__name {
  color: #6e6b7b;
  font-weight: 500;
}

.text__id {
  color: #b9b9c3;
  font-weight: 400;
}

.past-site-access-row {
  margin-top: 14px;
}

.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.mt-4px {
  margin-top: 4px;
}

.mt-8px {
  margin-top: 8px;
}

.table-container-height {
  height: 500px;
}

.table-container-no-data-height {
  height: 543px;
}

.today-self-check-in-height {
  height: 721px;
  overflow: auto;
}

.today-self-check-in-no-data-height {
  height: 720px;
}

.icon_folder {
  width: 70px;
  height: 70px;
}

@media (max-width: 992px) {
  .today-self-check-in-count__container {
    margin-top: 0;
    padding-left: 7px;
    padding-right: 14px;
  }

  .site-access-status__container {
    padding-right: 14px;
  }

  .today-site-approved__container {
    padding-left: 7px;
  }

  .today-site-access__container {
    margin-top: 14px;
    padding-left: 7px;
  }

  .today-self-check-in-height {
    height: 500px;
  }

  .today-self-check-in-no-data-height {
    height: 500px;
  }
}

@media (min-width: 992px) and (max-width: 1840px) {
  .today-self-check-in-count__container {
    margin-top: 14px;
  }

  .today-self-check-in-height {
    height: 572px;
  }

  .today-self-check-in-no-data-height {
    height: 572px;
  }
}
</style>
